module.exports = __webpack_public_path__ + "static/media/free-sign-up__4.9cb33cc9.svg";